module.exports = __webpack_public_path__ + "img/afrika_nap_program-01.d12052a6.jpg";